import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { enableMock } from '@/api/mock';
import App from './App.vue';
import router from './router';
import 'vant/lib/index.css';
import '@/styles/global.css';

// 导入全部 Vant 组件
import Vant from 'vant';

(async () => {
    // await enableMock(); // 根据 .env 开关

    const app = createApp(App);

    // 注册全部 Vant 组件
    app.use(Vant);

    app.use(createPinia()).use(router).mount('#app');
})();
